import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/Logo";

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { user, ready, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => { if (ready && user) nav("/admin"); }, [ready, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back to KLYROO");
      nav("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-klyroo-bg klyroo-radial flex items-center justify-center px-4">
      <div className="klyroo-grid absolute inset-0 opacity-40" />
      <div className="relative w-full max-w-sm card-surface rounded-3xl p-8">
        <Link to="/" className="flex flex-col items-center gap-3 mb-6">
          <LogoMark size={48} />
          <span className="font-display font-extrabold text-2xl text-white tracking-tight">KLYROO</span>
          <span className="overline">Admin CMS</span>
        </Link>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-mono text-slate-400">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              className="w-full mt-1 bg-klyroo-bg border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-klyroo-cyan/50" />
          </div>
          <div>
            <label className="text-xs font-mono text-slate-400">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" placeholder="••••••••"
              className="w-full mt-1 bg-klyroo-bg border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-klyroo-cyan/50" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full py-3 rounded-xl bg-klyroo-cyan text-black font-semibold hover:bg-white transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <Link to="/" className="block text-center text-xs font-mono text-slate-500 hover:text-klyroo-cyan mt-6">← Back to site</Link>
      </div>
    </div>
  );
}
